module.exports = __webpack_public_path__ + "assets/img/1432.99fedd39.png";